<template>
    <main-content with_go_back_bar>
        <transaction-app-report-filter
                :action="filterAction"
                :exportExcel="exportToExcel"
        >
        </transaction-app-report-filter>
        <div>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__body" style="color: black; background-color: #fff">
                            <h6> {{ $t('label.total_transactions') }}</h6>
                            <div class="text-center">
                                <h4 class="fix-margin">
                                    {{subsetAppReportStatistics.total_transactions}}
                                    <span style="font-size: 1.5rem">
                                        {{' ' + $t('currency.rial')}}
                                    </span>
                                </h4>
                            </div>
                        </div>
                    </div>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__body" style="color: black; background-color: #fff">
                            <h6>{{ $t('label.succeeded_transactions_number') }}</h6>
                            <div class="text-center">
                                <h4 class="fix-margin"> {{subsetAppReportStatistics.number}} </h4>
                            </div>
                        </div>
                    </div>
                </kt-col>
            </kt-row>
        </div>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </main-content>
</template>

<script>

import transactionsReportFilter from "./components/transactions-app-report-filter";
import mainContent from '@/components/main-content'
import axios from "axios";
import { ApiUrl } from '@/common/api.service'
import columns from "./datatable/transactions-app-report-columns";
import { AuthorizationHeader } from '@/common/jwt.service'
import {mapGetters} from "vuex";
import $ from "jquery";
import { KTApp } from '@/plugins/core/app'
import toastr from "toastr";
import { i18n } from '@/plugins/i18n'
import store from '@/store'

export default {
    name: "gateway_transactions_report",
    components: {
        mainContent,
        'transaction-app-report-filter': transactionsReportFilter
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            query: {},
            subset_user_id: this.$route.params.user_id,
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "app_transactions_report_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path(`marketing/subset-app-transactions-report/${this.subset_user_id}`),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,

            }
        },
        ...mapGetters('marketing', [
            'status',
            'subsetAppReportStatistics'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
            this.fetchReportStatistics(this.subset_user_id)
        },
        exportToExcel(e, query){
            let btn = $('#export_app_transations_btn')
            KTApp.progress(btn)

            this.query = query
            axios({
                url: ApiUrl.path(`marketing/export-transactions-app-report/${this.subset_user_id}`),
                method: 'GET',
                params: this.query,
                responseType: 'blob',
            }).then((response) => {
                KTApp.unprogress(btn)
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'transactions.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            }).catch(({response}) => {
                this.toastr.error(i18n.t('message.an_error_accord'))
                KTApp.unprogress(btn)
            })
        },
        fetchReportStatistics(hashid) {
            setTimeout(function () {
                store.dispatch('marketing/fetchAppReportStatistics', hashid)
            }, 1000)
        }
    },
    mounted() {
        this.fetchReportStatistics(this.subset_user_id)
    }
}

</script>